const getHardwareData = async () => {
  let hardwareData = {};
  try {
    // Battery info
    hardwareData.hasBatteryAPI =
      "getBattery" in navigator || "battery" in navigator;
    if (hardwareData.hasBatteryAPI) {
      const batteryInfo = await navigator.getBattery();
      hardwareData.batteryLevel = batteryInfo.level;
      hardwareData.charging = batteryInfo.charging;
      hardwareData.chargingTime = batteryInfo.chargingTime;
      hardwareData.dischargingTime = batteryInfo.dischargingTime;
    }

    // Computation time
    const start = performance.now();
    for (let i = 0; i < 1e6; i++) Math.sqrt(i);
    const end = performance.now();
    hardwareData.computationTime = end - start;

    hardwareData.screenWidth = window.screen.width;
    hardwareData.screenHeight = window.screen.height;
    hardwareData.devicePixelRatio = window.devicePixelRatio;

    // Screen color support
    hardwareData.supportsP3 = window.matchMedia("(color-gamut: p3)").matches;

    // Touch support capabilities
    hardwareData.touchSupport = "ontouchstart" in window;

    // GPU info
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    const dbgInfo = gl.getExtension("WEBGL_debug_renderer_info");
    hardwareData.gpuVendor = gl.getParameter(dbgInfo.UNMASKED_VENDOR_WEBGL);
    hardwareData.gpuRenderer = gl.getParameter(dbgInfo.UNMASKED_RENDERER_WEBGL);
    hardwareData.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    hardwareData.maxCubeMapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    hardwareData.maxRenderbufferSize = gl.getParameter(
      gl.MAX_RENDERBUFFER_SIZE
    );
    hardwareData.maxVaryingVectors = gl.getParameter(gl.MAX_VARYING_VECTORS);
    hardwareData.maxVertexAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    hardwareData.maxVertexUniformVectors = gl.getParameter(
      gl.MAX_VERTEX_UNIFORM_VECTORS
    );
    hardwareData.maxTextureImageUnits = gl.getParameter(
      gl.MAX_TEXTURE_IMAGE_UNITS
    );
    hardwareData.shadingLanguageVersion = gl.getParameter(
      gl.SHADING_LANGUAGE_VERSION
    );

    // Detect safe area inset (notch)
    const testDiv = document.createElement("div");
    testDiv.style.paddingTop = "env(safe-area-inset-top)";
    document.body.appendChild(testDiv);
    hardwareData.safeAreaTop =
      parseInt(window.getComputedStyle(testDiv).paddingTop) || 0;
    document.body.removeChild(testDiv);

    // RAF jitter - measure frame timing consistency
    hardwareData.rafJitter = await new Promise((resolve) => {
      let last = performance.now();
      let count = 0;
      const jit = [];
      function raf(t) {
        jit.push(t - last);
        last = t;
        if (++count < 120) {
          requestAnimationFrame(raf);
        } else {
          const mean = jit.reduce((a, b) => a + b, 0) / jit.length;
          const stdev = Math.sqrt(
            jit.map((x) => (x - mean) ** 2).reduce((a, b) => a + b, 0) /
              jit.length
          );
          resolve({ mean, stdev });
        }
      }
      requestAnimationFrame(raf);
    });
    return hardwareData;
  } catch (e) {
    console.error("Error getting an emulator prediction:", e);
    return Promise.resolve(undefined);
  }
};

export default getHardwareData;
